__webpack_require__.p = "/local/components/iek/catalog2.0/build/";